import httpClient from "../http/http-client";
import { IRegulatedEmissionTradingScheme } from './regulated-emission-trading-scheme.model';

export default class RegulatedEmissionTradingSchemeService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IRegulatedEmissionTradingScheme[]> {
    return this.http.get('/regulated-emission-trading-scheme')
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}